<template>
  <v-app>
      <v-main style="height: 85%;">
            <slot />
    </v-main>
  </v-app>
</template>
<script setup lang="ts">
</script>